<template>
  <div class="detail-container">
    <h1>建物種別情報詳細</h1>
    <div v-if="building_type">
      <table class="table table-bordered">
        <tr>
          <th>建物種別</th>
          <td>{{ building_type.building_type_nm }}</td>
        </tr>
        <tr>
          <th>並び順</th>
          <td>{{ building_type.sort_no }}</td>
        </tr>
      </table>

      <div class="btn-area">
        <router-link :to="{ name: 'BuildingTypeList', params: { id: building_type.id }}"> <!-- 顧客情報編集ページへのリンク -->
          <button type="button" class="btn btn-primary">一覧へ</button>
        </router-link>

        <router-link v-if="isAdmin" :to="{ name: 'BuildingTypeEdit', params: { id: building_type.id }}"> <!-- 顧客情報編集ページへのリンク -->
          <button type="button" class="btn btn-success mx-2">編集</button>
        </router-link>
      </div>
    </div>
    <!-- その他の詳細情報 -->
    <div v-else>
      建物種別情報情報を読み込み中...
    </div>
  </div>
</template>

<script>
import { ref, onMounted, watchEffect, computed } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import { getBuildingType } from '@/api/axios';
import { currentRoleFromStoreOrLocalStorage, isAdminRole } from '@/utils/roleAuthorization';

export default {
  setup() {
    const title = ref('建物種別情報詳細');
    const store = useStore();

    watchEffect(() => {
      document.title = title.value;
    });

    const isAdmin = computed(() => isAdminRole(currentRoleFromStoreOrLocalStorage(store.state.userRole)));
    const building_type = ref({});
    const route = useRoute();
    const buildingTypeId = route.params.id;

    const fetchBuildingType = async () => {
      const response = await getBuildingType(buildingTypeId, { include_visibility_hidden: true });
      building_type.value = response.data;
    };

    onMounted(fetchBuildingType);

    return {
      title,
      isAdmin,
      building_type
    };
  }
};
</script>

<style scoped>
.detail-container {
  padding: 20px;
  width: 70%;
  margin: auto;
  border: 1px solid #ddd;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.detail-item {
  margin-bottom: 10px;
}

table th {
  background: #2c3e50;
  color: #fff;
}

table th,
table td{
  padding: 8px;
}

.btn-area{
  text-align: center;
}
</style>
